module.exports = __webpack_public_path__ + "static/media/operations.d2741814.svg";